import React from "react";
import styled from "@emotion/styled";

// force it to be behind all
// const FooterSection = styled.div`
//   background-image: url(/wave-haikei-3.svg);
//   background-repeat: no-repeat;
//   background-size: cover;
//   width: 100%;
//   height: 400px;
//   position: relative;
//   z-index: -1;
//   span {

const FooterSection = styled.div`
  background-image: url(/wave-haikei-3.svg);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 400px;
  position: relative;
  z-index: -1;

  span {
    position: absolute;
    bottom: 4rem;
    color: #ff;

    a {
      text-decoration: underline;
    }
  }
`;
function Footer() {
  return (
    <FooterSection>
      <div className="Container" />
    </FooterSection>

  // <>
  //     <svg
  //       height="100%"
  //       width="100%"
  //       id="svg"
  //       viewBox="0 0 1440 400"
  //       xmlns="http://www.w3.org/2000/svg"
  //       style={{bottom: '800px'}}
  //     >
  //       <path
  //         d="M0 268L80 275.3C160 282.7 320 297.3 480 303.3C640 309.3 800 306.7 960 301.7C1120 296.7 1280 289.3 1360 285.7L1440 282L1440 401L1360 401C1280 401 1120 401 960 401C800 401 640 401 480 401C320 401 160 401 80 401L0 401Z"
  //         // d="M 0,400 C 0,400 0,200 0,200 C 114.35714285714289,156.53571428571428 228.71428571428578,113.07142857142858 351,131 C 473.2857142857142,148.92857142857142 603.4999999999998,228.25 713,248 C 822.5000000000002,267.75 911.2857142857144,227.92857142857142 1029,210 C 1146.7142857142856,192.07142857142858 1293.3571428571427,196.03571428571428 1440,200 C 1440,200 1440,400 1440,400 Z"
  //         stroke="none"
  //         strokeWidth="0"
  //         fill="#151515"
  //       ></path>
  //     </svg>


  //    <main>
  //     <svg
  //       height="100%"
  //       width="100%"
  //       id="svg"
  //       viewBox="0 0 1440 400"
  //       xmlns="http://www.w3.org/2000/svg"
  //     />

  //     <div className="Container" />
  //   </main> 
  //   </>
  );
}

export default Footer;
